import React from "react";
/* eslint-disable */
import Header from "../../header";
import Banner from "../Banner";
import SubNav from "../SubNav";
import Footer from "../../Footer";

const icon = require("../../../assets/Detasad Cloud/main_icon_highperformance.svg");

const DRAsAService = () => {
    const heading = `DR AS A SERVICE `;
    const details = `Achieve enterprise grade business continuity by using DETASAD cost-effective DR as a Service.`;

    const overview = [
        `Today, business runs as a digital function where each workload has its own criticality definition. Business demands disaster recovery and continuity services in order to ensure seamless functionality and operations. DETASAD cloud offering fully covers BC DR aspects by adopting multiple industry proven methodologies depending upon business RPO and RTO definitions.`,
        `With many use cases as offering, mentioned below, customer can use all or any to achieve business goals. The services involve could be from customer site to DETASAD cloud and vice versa or to supported 3rd party cloud service provider. Customer will get related reporting & monitoring services accordingly.`
    ];

    const advantages = [
        [
            `DRaaS as DR Site`,
            `To achieve BC/DR customer can built DR site at DETASAD datacenter. This will be economical in compare to customer owned DR site.`,
            icon
        ],
        [
            `DRaaS for Passive Workload`,
            `VM level application consistent asynchronous replication services from production workload to DR site. This service uses storage at DR site and VM will be active as per need during disaster time.`,
            icon
        ],
        [
            `DRaaS for Databases`,
            `To achieve enterprise grade RPO/RTO, DETASAD provide option to establish BCDR practice by using application and database built-in replication features.`,
            icon
        ],
        [
            `No Interruptions`,
            `Just a few simple clicks will allow your personnel to check fail-safe assurance without data loss or downtime.`,
            icon
        ]
    ];

    const functions = [
        [
            `Rapid Restoration`,
            [
                `In case of a disaster, services can be quickly restored in the target availability zone with minimal interruption to services.`
            ]
        ],
        [`Cloud Disaster Recovery`, [`Easily recover your cloud’s data using DETASAD’s DR as a Service`]],
        [`Supported platforms`, [`x86 based BareMetal / Physical, VMware and KVM`]]
    ];

    const functionsDetailed = [
        `Disaster recovery and migration process consists of components (devices) replication of business applications and infrastructure items to a secondary datacenter and launching failover from one of restore points. Failover runs on the secondary datacenter; wherein original IT infrastructure is restored with all its dependencies.`,
        `DETASAD offering Disaster Recovery solution for business applications and IT infrastructure in case of disaster from customer premises (Physical or Virtualized) to DETASAD cloud or between different DETASAD Regions.`
    ];
    return (
        <div>
            <Header />
            <Banner heading={heading} details={details} />
            <SubNav
                overview={overview}
                advantages={advantages}
                functions={functions}
                // functionsDetailed={functionsDetailed}
            />
            <Footer />
        </div>
    );
};

export default DRAsAService;
